import React from "react";

import { ErrorBoundary } from "react-error-boundary";

export default function ErrorBoundaryWrapper({ children }) {
  return <ErrorBoundary fallback={<div>An error occured</div>}>{children}</ErrorBoundary>;
}
